export enum HouseholdClaimRoutes {
    Root = "/siniestros/hogar",
    Booking = "/siniestros/hogar/reserva",
    DeclarationOfAssets = "/siniestros/hogar/reserva/declaracion-de-bienes",
    BookingDamage = "/siniestros/hogar/reserva/danos/qa",
    BookingPending = "/siniestros/hogar/registros-pendientes",
    BookingDone = "/siniestros/hogar/reserva/:claimId/terminado",

    // * Register
    Registration = "/siniestros/hogar/registro/:claimId",
    DocumentsUpload = "/siniestros/hogar/registro/:claimId/documentos",
    AccountData = "/siniestros/hogar/registro/:claimId/datos-abono",
    RegisterDone = "/siniestros/hogar/registro/:claimId/terminado",

    // * Process
    Results = "/siniestros/hogar/proceso/:claimId",
    EvaluationResults = "/siniestros/hogar/proceso/:claimId/resultados-de-evaluacion",
    CompensationApproved = "/siniestros/hogar/proceso/:claimId/resumen-de-aprobacion",
    AdjusterSelection = "/siniestros/hogar/proceso/:claimId/seleccion-de-ajustador",
    AdjusterDone = "/siniestros/hogar/proceso/:claimId/terminado",
}
